import React from 'react';

class TeamDropdownSeasonCfg extends React.Component {

  constructor(props) {
		super(props);
		this.createSelectItem = this.createSelectItem.bind(this);
	}

	render() {
		//console.log('TeamDropdownSeasonCfg: render')
		return (
			<select className="form-control" value={this.props.value} onChange={this.props.teamChange} name={this.props.teamNumber}>
				{this.props.teams.map(this.createSelectItem)}
			</select>
		);
	}

	createSelectItem(team, idx) {
		return (
			<option value={idx} key={idx}>{team.name}</option>
		);
	}

}

export default TeamDropdownSeasonCfg;